import React, { useState, useEffect, useRef } from "react";
import { Editor } from "@tinymce/tinymce-react";

import "./index.scss";

///new
// TinyMCE so the global var exists
// eslint-disable-next-line no-unused-vars
// import tinymce from "tinymce/tinymce";
// DOM model
// import "tinymce/models/dom/model";
// // Theme
// import "tinymce/themes/silver";
// // Toolbar icons
// import "tinymce/icons/default";
// // Editor styles
import "tinymce/skins/ui/oxide/skin.min.css";

// importing the plugin js.
// if you use a plugin that is not listed here the editor will fail to load
// import "tinymce/plugins/advlist";
// import "tinymce/plugins/anchor";
// import "tinymce/plugins/autolink";
// import "tinymce/plugins/autoresize";
// import "tinymce/plugins/autosave";
// // import "tinymce/plugins/charmap";
// import "tinymce/plugins/code";
// import "tinymce/plugins/codesample";
// import "tinymce/plugins/directionality";
// import "tinymce/plugins/emoticons";
// import "tinymce/plugins/fullscreen";
// import "tinymce/plugins/image";
// import "tinymce/plugins/importcss";
// import "tinymce/plugins/insertdatetime";
// import "tinymce/plugins/link";
// import "tinymce/plugins/lists";
// import "tinymce/plugins/media";
// import "tinymce/plugins/nonbreaking";
// import "tinymce/plugins/pagebreak";
// import "tinymce/plugins/preview";
// import "tinymce/plugins/quickbars";
// import "tinymce/plugins/save";
// import "tinymce/plugins/searchreplace";
// // import "tinymce/plugins/table";
// import "tinymce/plugins/template";
// import "tinymce/plugins/visualblocks";
// import "tinymce/plugins/visualchars";
// import "tinymce/plugins/wordcount";
// import "tinymce/plugins/quickbars";
// // importing plugin resources
// import "tinymce/plugins/emoticons/js/emojis";

/* eslint import/no-webpack-loader-syntax: off */
import contentCss from "!!raw-loader!tinymce/skins/content/default/content.min.css";
import contentUiCss from "!!raw-loader!tinymce/skins/ui/oxide/content.min.css";

const RichTextEditorViewWheel = ({
  name,
  value: externalValue,
  id,
  onBlur,
  onChange,
  error,
  disabled,
  handleEditorSetup,
  handleSetContent,
  editorRef,
}) => {
  const [value, setValue] = useState(externalValue || "");

  useEffect(() => {
    if (externalValue !== undefined && externalValue !== null) {
      setValue(externalValue);
    } else {
      setValue("");
    }
  }, [externalValue]);

  const handleEditorChange = (newValue) => {
    setValue(newValue);
    if (onChange) onChange(newValue);
  };

  return (
    <div className={"editor"}>
      <Editor
        // onInit={(evt, editor) => (editorRef.current = editor)}
        apiKey="czfai1zvqc5guwh8imgx9qkdhd8b5bcwxz6b094t5zo5wulw"
        init={{
          setup: handleEditorSetup,
          // height: "76vh",
          height: "73vh",
          width: "100%",
          selector: "#viewWheel",
          id: "#viewWheel",
          statusbar: false,
          skin: false,
          content_css: false,
          // contextmenu: false,
          contextmenu: "undo redo | copy paste2 cut ",
          format_noneditable_selector: "",
          // image_advtab: true,
          content_style: [
            contentCss,
            contentUiCss,
            "body { font-family: DM Sans; color: #0F0F0F; line-height:1 ; background-color: #FFFFFF }; ",
            "img { max-width: 100%; height: auto; }",
            "iframe, object, embed, video { max-width: 100%; }",
            // "img.left { margin-right: 10px; margin-bottom: 10px;float: left}; img.right { margin-left: 10px;margin-bottom: 10px; float: right};",
          ].join("\n"),
          menubar: false,
          object_resizing: "img,iframe",
          quickbars_image_toolbar:
            "inlineButton breakTextButton wrapTextButton wrapTextButtonRight ",
          // quickbars_image_toolbar:
          //   "alignleft aligncenter alignright  alignnone",
          quickbars_selection_toolbar:
            "alignleft aligncenter alignright alignnone",
          quickbars_insert_toolbar: false,
          resize_img_proportional: true,
          // color_default_foreground: "#0DEDFF",
          // color_cols: 2,
          link_assume_external_targets: "https",
          link_default_target: "_blank",
          link_target_list: false,
          link_title: false,

          //   menu: Menu,
          toolbar: false,
          // toolbar1:
          //   "fontfamily | bold italic underline | alignleft aligncenter alignright | bullist numlist",
          // toolbar2: "link emoticons media",

          font_family_formats:
            "DM Sans=DM Sans;Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva;",
        }}
        onEditorChange={handleEditorChange}
        // onSetContent={handleSetContent}
        onBlur={onBlur}
        id={`text-${id}`}
        name={name}
        value={value}
        disabled={true}
      />
    </div>
  );
};

export default RichTextEditorViewWheel;
